// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".InteractiveTooltip__tooltipRect___2IlZN{display:flex;min-width:-moz-max-content;min-width:max-content;position:absolute;transform:translate(-50%,-100%);z-index:999999}", ""]);
// Exports
exports.locals = {
	"tooltipRect": "InteractiveTooltip__tooltipRect___2IlZN"
};
module.exports = exports;
